export default __webpack_public_path__ + "static/media/arrowdown.8f848f5d.png";